import React from 'react';
import { NADFUN_TOKEN_URL } from '../../config/constants';

const HowToBuy: React.FC = () => {
    const steps = [
        {
            number: '01',
            emoji: '👛',
            title: 'Get a Wallet',
            description: 'Download MetaMask or any EVM-compatible wallet. Set up your account and secure your seed phrase.',
        },
        {
            number: '02',
            emoji: '⛽',
            title: 'Get MON',
            description: 'Bridge assets to Monad network or buy MON directly. You\'ll need MON for gas fees and to swap for $DUCK.',
        },
        {
            number: '03',
            emoji: '🦆',
            title: 'Visit nad.fun',
            description: 'Head to nad.fun and find the $DUCK token page. Connect your wallet and you\'re ready to quack!',
        },
        {
            number: '04',
            emoji: '🚀',
            title: 'Buy $DUCK',
            description: 'Enter the amount of MON you want to swap for $DUCK. Confirm the transaction and welcome to the pond!',
        },
    ];

    return (
        <section id="how-to-buy" className="section how-to-buy-section">
            <h2 className="section-title">🛒 How to Buy $DUCK</h2>
            <p className="htb-subtitle">
                Join the quack revolution in 4 simple steps
            </p>

            <div className="htb-steps">
                {steps.map((step, index) => (
                    <div key={index} className="htb-step glass-card">
                        <div className="htb-step-number">{step.number}</div>
                        <div className="htb-step-emoji">{step.emoji}</div>
                        <h3 className="htb-step-title">{step.title}</h3>
                        <p className="htb-step-desc">{step.description}</p>
                        {index < steps.length - 1 && (
                            <div className="htb-step-arrow">→</div>
                        )}
                    </div>
                ))}
            </div>

            <div className="htb-cta">
                <a
                    href={NADFUN_TOKEN_URL}
                    target="_blank"
                    rel="noreferrer"
                    className="htb-buy-btn"
                >
                    <span className="htb-buy-btn-icon">🦆</span>
                    Buy $DUCK Now on nad.fun
                </a>
            </div>
        </section>
    );
};

export default HowToBuy;
